import { createOtelBuilder } from "./otel-builder";
import SentryLoggerProvider from "./sentry-logger-provider";
import { SentryOtelTracerProvider } from "./sentry/sentry-otel-trace-provider";
import config from "../config";

const telemetry = createOtelBuilder("my-web-app")
  .withSamplingRatio(config.telemetryConfig.samplingRatio)
  .withTracing((tracing) => {
    tracing.push(
      new SentryOtelTracerProvider({
        dsn: config.telemetryConfig.sentryDns,
      }),
    );
  })
  .withLogging((logging) => {
    logging.push(
      new SentryLoggerProvider({
        dsn: config.telemetryConfig.sentryDns,
        environment: config.environment,
      }),
    );
  })
  .build();

export default telemetry;

telemetry.initialize();
